// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"936":"0158fe42","963":"20dc6dde"}[chunkId] + ".chunk.js";
};